import { render, staticRenderFns } from "./ListDeletedFunnels.vue?vue&type=template&id=9dc8bfbc&"
import script from "./ListDeletedFunnels.vue?vue&type=script&lang=ts&"
export * from "./ListDeletedFunnels.vue?vue&type=script&lang=ts&"
import style0 from "./ListDeletedFunnels.vue?vue&type=style&index=0&id=9dc8bfbc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports